module.exports = __webpack_public_path__ + "static/img/LinkFailure.cbc9fb20.png";